import { create } from "zustand";
import { getData } from "../utils/formHelpers";
import { ProcessingCategoryType } from "../../app/types/genericTables.types";

type UseProcessingCategoryType = {
  processingCategoryList: ProcessingCategoryType[];
  get: (id: ProcessingCategoryType["id"]) => ProcessingCategoryType | undefined;
  query: string;
  setQuery: (query: string) => void;
  fetchAll: () => void;
  loading: boolean;
};

export const useProcessingCategory = create<UseProcessingCategoryType>(
  (set, get) => ({
    loading: false,
    processingCategoryList: [],
    query: "",
    setQuery: (query) => set({ query }),
    get: (id) =>
      get().processingCategoryList.find(
        (processingCategory) => processingCategory.id === id
      ),
    fetchAll: async () => {
      set({ loading: true });
      try {
        const endpoint = "/generic/ProcessingCategory";
        const { data: response } = await getData(endpoint);
        set(() => ({
          processingCategoryList: response,
          loading: false,
        }));
      } catch (error) {
        console.error("Error fetching analysisTypeList:", error);
        set({ loading: false });
      }
    },
  })
);
